import { gql, useMutation } from '@apollo/client';

import { GET_JOB_BY_ID } from './get-job-by-id.hook';

export const DELETE_JOB_LOCATIONS_BY_IDS = gql`
  mutation deleteJobLocationsByIds($jobLocationsIds: [ObjectId!]!, $jobId: ObjectId!) {
    deleteJobLocationsByIds(jobLocationsIds: $jobLocationsIds, jobId: $jobId)
  }
`;

export const useDeleteJobLocationsByIds = () => {
  const [deleteJobLocationsByIds] = useMutation(DELETE_JOB_LOCATIONS_BY_IDS, {
    refetchQueries: [GET_JOB_BY_ID],
  });

  return deleteJobLocationsByIds;
};
